export const PRODUCTION = 'production';
export const TESTING = 'testing';
export const STAGING = 'staging';

export function getEnvClassName(environment: string, isTransparent: boolean): string {
  const suffix = isTransparent ? '_transparent' : '';
  const envClass: {[key: string]: string} = {
    [PRODUCTION]: 'common_clinch_navbar_production',
    [TESTING]: 'common_clinch_navbar_testing',
    [STAGING]: 'common_clinch_navbar_staging',
  };

  return (envClass[environment] || envClass[PRODUCTION]) + suffix;
}

export function copyToClipboard(value: string) {
  return navigator.clipboard.writeText(value);
}

export function setClipboardCustom(value: string) {
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(value);
  } else {
    try {
      const textarea: HTMLTextAreaElement = document.createElement('textarea');
      textarea.value = value;
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();
      document.execCommand('copy');
    } catch (e) {}
  }
}

export function randomKey() {
  return (
    (((1 + Math.random()) * 0x100000) | 0).toString(16).substring(1) +
    '-' +
    (((1 + Math.random()) * 0x100000) | 0).toString(16).substring(1)
  );
}
